import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as DeleteRedIcon } from "../assets/icons/delete_red.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";

export default function DeletePopup({
  isOpen,
  title = "Are you sure?",
  message = "Once deleted, you will not be able to recover this line item!",
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
          backdropFilter: "blur(2px)",
        }}
        onClick={onCancel}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            width: "480px",
            padding: "48px 24px 32px 24px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Icon in Top Right */}
          <CloseIcon
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "14px",
              height: "14px",
              cursor: "pointer",
              color: "#205a46",
            }}
            onClick={onCancel}
          />
          {/* Centered bold title */}
          <h2
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: "500",
              fontSize: "22px",
              color: "#111111",
              textAlign: "center",
              margin: "0 0 12px 0",
            }}
          >
            {title}
          </h2>

          {/* Centered description text */}
          <p
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "1.5",
              color: "#66827a",
              textAlign: "center",
              margin: "0 0 28px 0",
              width: "100%",
            }}
          >
            {message}
          </p>

          {/* Buttons Row: Delete on Left, Cancel on Right */}
          <div
            style={{
              display: "flex",
              gap: "16px",
              width: "100%",
              justifyContent: "center",
            }}
          >
            {/* Delete Button (Red background, white text, delete icon in front) */}
            <button
              onClick={onConfirm}
              style={{
                backgroundColor: "#E30000",
                color: "#ffffff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 24px",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                boxShadow: "0 2px 6px rgba(227, 0, 0, 0.2)",
                transition: "background-color 0.2s",
                minWidth: "120px",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#b80000")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#E30000")}
            >
              <DeleteRedIcon
                style={{
                  width: "16px",
                  height: "16px",
                  filter: "brightness(0) invert(1)", // Turn the red icon white for contrast
                }}
              />
              Delete
            </button>

            {/* Cancel Button (White background, border c2e6d1, dark text) */}
            <button
              onClick={onCancel}
              style={{
                backgroundColor: "#ffffff",
                color: "#205a46",
                border: "1px solid #c2e6d1",
                borderRadius: "10px",
                padding: "10px 24px",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "border-color 0.2s, background-color 0.2s",
                minWidth: "120px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f4faf5";
                e.currentTarget.style.borderColor = "#a0dabc";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.borderColor = "#c2e6d1";
              }}
            >
              Cancel
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
